// import axios from 'axios'
import api from '../utils/api'

export const sendOTP = (data) => api.post(process.env.VUE_APP_OTP, data)